import { createIcon } from '@chakra-ui/icons';

export const PaperPlane = createIcon({
    displayName: 'PaperPlane',
    viewBox: '0 0 24 24',
    path: [
        <path
            key={0}
            color='currentColor'
            d='m8.75 17.612v4.638c0 .324.208.611.516.713.077.025.156.037.234.037.234 0 .46-.11.604-.306l2.713-3.692z'
        />,
        <path
            key={1}
            color='currentColor'
            d='m23.685.139c-.23-.163-.532-.185-.782-.054l-22.5 11.75c-.266.139-.423.423-.401.722.023.3.222.556.505.653l6.255 2.138 13.321-11.39-10.308 12.419 10.483 3.583c.078.026.16.04.242.04.136 0 .271-.037.39-.109.19-.116.319-.311.352-.53l2.75-18.5c.041-.28-.077-.558-.307-.722z'
        />,
    ],
});

export const PasteIcon = createIcon({
    displayName: 'PasteIcon',
    viewBox: '0 0 512.001 512.001',
    path: [
        <path
            key={0}
            d='M481,371c11.046,0,20-8.954,20-20v-92c0-33.084-26.916-60-60-60h-39v-79c0-44.112-35.888-80-80-80h-47.533c-7.739-23.749-29.864-40-55.16-40h-25.614c-25.296,0-47.421,16.251-55.16,40H91c-44.112,0-80,35.888-80,80v312c0,44.112,35.888,80,80,80h88c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20H91c-22.056,0-40-17.944-40-40V120c0-22.056,17.944-40,40-40h2v59c0,11.046,8.954,20,20,20h189c11.046,0,20-8.954,20-20V80c22.056,0,40,17.944,40,40v79h-65.007C263.914,199,237,225.913,237,258.993v193.015c0,33.08,26.916,59.993,60.01,59.993L441,511.926c33.084,0,60-26.913,60-59.992c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20c0,11.024-8.972,19.992-20.01,19.992L297,472c-11.028,0-20-8.969-20-19.993V258.993c0-11.024,8.969-19.993,19.993-19.993H441c11.028,0,20,8.972,20,20v92C461,362.046,469.955,371,481,371z M282,119H133V80h21c9.177,0,17.177-6.246,19.403-15.149l2.798-11.194C178.211,45.616,185.404,40,193.693,40h25.614c8.289,0,15.481,5.616,17.492,13.657l2.798,11.194C241.823,73.754,249.823,80,259,80h23V119z'
        />,
        <path
            key={1}
            d='M401,279h-64c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h64c11.046,0,20-8.954,20-20C421,287.954,412.047,279,401,279z'
        />,
        <path
            key={2}
            d='M401,349h-64c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h64c11.046,0,20-8.954,20-20C421,357.954,412.047,349,401,349z'
        />,
    ],
});

export const EtherscanIcon = createIcon({
    displayName: 'EtherscanIcon',
    viewBox: '0 0 293.775 293.671',
    path: [
        <path
            key={0}
            data-name='Path 1'
            d='M61.055 139.822a12.45 12.45 0 0112.508-12.452l20.737.068a12.467 12.467 0 0112.467 12.467v78.414c2.336-.692 5.332-1.43 8.614-2.2a10.389 10.389 0 008.009-10.11v-97.266a12.469 12.469 0 0112.468-12.47h20.778a12.469 12.469 0 0112.467 12.467v90.279s5.2-2.106 10.269-4.245a10.408 10.408 0 006.353-9.577V77.57a12.466 12.466 0 0112.466-12.467h20.778a12.468 12.468 0 0112.468 12.467v88.625c18.014-13.055 36.271-28.758 50.759-47.639a20.926 20.926 0 003.185-19.537A146.6 146.6 0 00148.737.013C67.298-1.081-.007 65.398.001 146.847a146.371 146.371 0 0019.5 73.45 18.56 18.56 0 0017.707 9.173 508.86 508.86 0 0014.643-1.518 10.383 10.383 0 009.209-10.306v-77.824'
            fill='#21325b'
        />,
        <path
            key={1}
            data-name='Path 2'
            d='M60.603 265.58a146.808 146.808 0 00233.172-118.741c0-3.381-.157-6.724-.383-10.049-53.642 80-152.686 117.4-232.79 128.793'
            fill='#979695'
        />,
    ],
});
